module.exports = __webpack_public_path__ + "img/music_thumbnail-400x300.02e7d94f.jpg";